import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class LoadingQueueService {
  private readonly _loadingQueueKey: string = "LOADING";  // Localstorage key
  private _loadingQueue: Array<string> = [];

  constructor() { }

  get loadingQueueKey() {
    return this._loadingQueueKey
  }

  get loadingQueue() {
    return this._loadingQueue
  }

  /**
   * Adds an API call to the queue
   * 
   * Returns the new length of the queue 
   */
  public enqueueApiCall(apiCall: string): number {
    this.addApiCallToQueue(apiCall);
    return this._loadingQueue.length;
  }

  /**
   * Removes an API call from the queue
   * 
   * Returns the new length of the queue
   */
  public dequeApiCall(apiCall: string): number {
    this.removeApiCallFromQueue(apiCall);
    return this._loadingQueue.length;
  }

  /**
   * Clears the queue in storage
   */
  public clearQueue(): void {
    this._loadingQueue = [];
    localStorage.removeItem(this._loadingQueueKey);
  }

  private loadQueue(): Array<string> {
    const queueStr = localStorage.getItem(this._loadingQueueKey);
    return queueStr == null ? [] : JSON.parse(queueStr);
  }

  private setQueue(queue: Array<string>): void {
    localStorage.setItem(this._loadingQueueKey, JSON.stringify(queue));
  }

  private removeApiCallFromQueue(apiCall: string): void {
    const queue = this.loadQueue();
    const apiCallIndex = queue.indexOf(apiCall);

    if (apiCallIndex < 0) {
      return
    }

    queue.splice(apiCallIndex, 1);
    this._loadingQueue = queue;
    this.setQueue(queue);
  }

  private addApiCallToQueue(apiCall: string): void {
    if (this.loadingQueue.includes(apiCall)) {
      return
    }

    this._loadingQueue.push(apiCall);
    this.setQueue(this._loadingQueue);
  }
}